import { render, staticRenderFns } from "./ClaimMessages.vue?vue&type=template&id=8f26c5d0&"
import script from "./ClaimMessages.vue?vue&type=script&lang=js&"
export * from "./ClaimMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports